<template>
  <div class="autocomplete">
    <div class="autocomplete-field">
      <input @click="opened = !opened" type="text" @input="vTypeText" @keyup="searching" v-model="searchQuery" />
      <span class="input-clear" @click="vInputClear"><i class="material-icons">close</i></span>
    </div>
    <div class="autocomplete-dropdown" v-show="opened">
      <ul>
        <li v-for="(item, index) in filteredArray" @click="vSelected(item)" :key="index">{{item[itemoption[0]]}}</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      searchQuery: "",
      isTyping: false,
      searchResult: [],
      isLoading: false,
      timer: null,
      opened: false,
    }
  },
  props: {
    placeholder: {
      type: String,
      default: 'Saisir ici',
    },
    delay: {
      type: String,
      default: '1000',
    },
    func: {
      type: Function,
      default: () => {}
    },
    prefilled: {
      type: Array, 
      default: () => []
    },
    itemoption: {
      type: Array,
      default: () => ['id', 'libelle'],
    },
    ajax: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.searchResult = this.$props.prefilled;
  },
  methods: {
    searching() {
      if(this.$props.ajax === true) {
        clearTimeout(this.timer);
        if(this.searchQuery != '') {
          this.timer = setTimeout(() => {
            this.$props.func(this.searchQuery).then(res => {
              this.searchResult = res
              this.opened = true;
            }); 
          }, Number(this.$props.delay));
        }
      }
    },
    vInputClear() {
      this.searchQuery = ''
      this.$emit("autocomplete:selected", {});
      this.opened = false;
    },
    vSelected(item) {
      this.searchQuery = item[this.$props.itemoption[1]];
      this.$emit("autocomplete:selected", item);
      this.opened = false;
    },
    vTypeText($event) {

      var arr = Array();
      arr[this.$props.itemoption[1]] = $event.target.value
      this.$emit("autocomplete:selected", arr);
    }
  }, 
  computed: {
    filteredArray() {

      let filtered = this.searchResult;
      
      if(this.selectFilter === '' || this.$props.ajax === true) {
        return filtered
      }

      let searchOption = this.$props.itemoption[1] !== undefined 
        ? this.$props.itemoption[1] 
        : this.$props.itemoption[0];
      
      filtered = filtered.filter(record => `${record[searchOption]}`.startsWith(this.searchQuery));

      return filtered;
    }
  },
}
</script>

<style scoped>
.autocomplete {
  position: relative;
}
.autocomplete .autocomplete-dropdown {
  border-left: solid 1px #e9e9e9;
  border-right: solid 1px #e9e9e9;
  border-bottom: solid 1px #e9e9e9;
  max-height: 285px;
  overflow-y: scroll;
  position: absolute;
  width: 100%;
  background-color: #fff;
  z-index: 10;
}
.autocomplete .autocomplete-dropdown ul {
  margin: 0;
  padding: 0;
}
.autocomplete .autocomplete-dropdown ul li {
  padding: 9px 20px;
  transition: all .3s;
  font-size: var(--fz-md);
}
.autocomplete .autocomplete-dropdown ul li:hover {
  cursor: pointer;
  background-color: #e4e4e4;
}
.autocomplete-field {
  display: flex;
  align-items: center;
  position: relative;
}
.input-clear {
  position: absolute;
  right: 10px;
  background-color: #cacaca;
  width: 20px;
  height: 20px;
  text-align: center;
  border-radius: 50%;
  transition: all .3s;
}
.input-clear:hover {
  cursor: pointer;
  background-color: #989898;
}
.input-clear i {
  font-size: 0.9rem;
  color: #fff;
}
</style>